<mat-form-field
  [class.hide-default-arrow-icon]="overrideArrowIcon"
  [class.mat-select-auto-width]="fitContent"
  [class.small]="size === 'small'"
  [appearance]="appearance"
  [class.slim-form-field]="isSlimFormField"
  [subscriptSizing]="subscriptSizing">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <ng-content select=".project-before-mat-select"></ng-content>
  <mat-select
    #select
    disableOptionCentering
    msInfiniteScroll
    [value]="value"
    [disabled]="disabled"
    [threshold]="'5%'"
    (infiniteScroll)="scrollEnd.emit()"
    [multiple]="multiple"
    [placeholder]="placeholder"
    [panelWidth]="matchTriggerWidth ? 'auto' : null"
    (openedChange)="openedChange.emit($event)"
    [panelClass]="panelClass">
    @if (selectTriggerTpl) {
      <mat-select-trigger>
        <ng-container
          *ngTemplateOutlet="selectTriggerTpl; context: { $implicit: { initialValue: initialValue, value: value, matOption: select.selected } }"></ng-container>
      </mat-select-trigger>
    }
    @if (!hideInput) {
      <sg-auto-complete-input [control]="autoCompleteFormControl" [placeholder]="searchInputPlaceholder"></sg-auto-complete-input>
    }
    <ng-container *ngTemplateOutlet="asyncTemplate; context: { $implicit: {} }"></ng-container>
    @if (!options || options.length === 0) {
      <mat-option disabled></mat-option>
    }
    <div class="sg-auto-complete-options-container">
      @for (opt of _structOptions; track $index) {
        @switch (opt.optGroup) {
          @case (true) {
            <mat-optgroup
              [ngClass]="{ 'sg-option-group': groupBy.selectableGroups, 'is-expended': !(collapsedGroupNames$ | async).get(opt.label) }"
              [attr.data-group-name]="opt.label"
              [label]="opt.label">
              @if (groupBy.selectableGroups) {
                <mat-checkbox
                  class="select-all-checkbox"
                  color="primary"
                  [checked]="(groupSelectStateByGroupName$ | async).get(opt.label) === 'all'"
                  [indeterminate]="(groupSelectStateByGroupName$ | async).get(opt.label) === 'indeterminate'"
                  (change)="toggleGroupSelection($event, opt)"></mat-checkbox>
              }
              @if (groupBy.expendableGroups) {
                <button type="button" mat-button (click)="expandCollapseGroup(opt)" class="sg-expend-btn">
                  <mat-icon>{{ !(collapsedGroupNames$ | async).get(opt.label) ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>
                </button>
              }
              <mat-option [value]="opt.label" style="display: none">{{ opt.label }}</mat-option>
              @for (oc of opt.value; track $index) {
                <mat-option
                  #matOption="matOption"
                  [value]="valueTransform ? valueTransform(oc) : oc"
                  [class.clear-mat-option-style]="clearOptionStyle"
                  [ngClass]="!(collapsedGroupNames$ | async).get(opt.label) ? 'sg-visible-group-option' : 'sg-hidden-group-option'">
                  <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: { initialValue: oc, matOption: matOption } }"></ng-container>
                </mat-option>
              }
            </mat-optgroup>
          }
          @default {
            <mat-option
              #matOption="matOption"
              [value]="valueTransform ? valueTransform(opt) : opt"
              [class.clear-mat-option-style]="clearOptionStyle"
              [title]="matOption?.getLabel()">
              <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: { initialValue: opt, matOption: matOption } }"></ng-container>
            </mat-option>
          }
        }
      }
    </div>
  </mat-select>
  @if (overrideArrowIcon) {
    <mat-icon matSuffix class="custom-select-arrow" [class.open]="isPanelOpen">expand_more</mat-icon>
  }
</mat-form-field>
